import React from 'react';

const SquashIcon = ({ isOpen }) => {
    const bezier = 'cubic-bezier(0, 0, 0, 1)';

    const size = 54;
    const lineWidth = 24;
    const left = (size - lineWidth) / 2;
    const middleTop = size / 2 - 1;
    const lineSpacing = 7;

    // Squash animation phases:
    // Opening: first moves to the center (0s delay), then rotates (0.2s delay)
    // Closing: first rotates back (0s delay), then moves apart (0.2s delay)
    const moveDelay = isOpen ? '0s' : '0.2s';
    const rotateDelay = isOpen ? '0.2s' : '0s';

    return (
        <div
            aria-hidden='true'
            className='mobile-nav-squash-icon'
            style={{
                width: `${size}px`,
                height: `${size}px`,
                position: 'relative',
                userSelect: 'none',
                display: 'inline-block',
                verticalAlign: 'middle',
                pointerEvents: 'none',
            }}>
            <div
                style={{
                    transition: `0.2s ${bezier} ${moveDelay}`,
                    transform: isOpen ? `translateY(${lineSpacing}px)` : 'none',
                }}>
                <div
                    style={{
                        background: 'currentColor',
                        height: '2px',
                        left: `${left}px`,
                        position: 'absolute',
                        width: `${lineWidth}px`,
                        top: `${middleTop - lineSpacing}px`,
                        transition: `0.2s ${bezier} ${rotateDelay}`,
                        transform: isOpen ? 'rotate(45deg)' : 'none',
                    }}
                />
            </div>

            <div
                style={{
                    transition: `0.2s ${bezier}`,
                    opacity: isOpen ? 0 : 1,
                }}>
                <div
                    style={{
                        background: 'currentColor',
                        height: '2px',
                        left: `${left}px`,
                        position: 'absolute',
                        width: `${lineWidth}px`,
                        top: `${middleTop}px`,
                        transition: `0.2s ${bezier}`,
                    }}
                />
            </div>

            <div
                style={{
                    transition: `0.2s ${bezier} ${moveDelay}`,
                    transform: isOpen ? `translateY(-${lineSpacing}px)` : 'none',
                }}>
                <div
                    style={{
                        background: 'currentColor',
                        height: '2px',
                        left: `${left}px`,
                        position: 'absolute',
                        width: `${lineWidth}px`,
                        top: `${middleTop + lineSpacing}px`,
                        transition: `0.2s ${bezier} ${rotateDelay}`,
                        transform: isOpen ? 'rotate(-45deg)' : 'none',
                    }}
                />
            </div>
        </div>
    );
};

export default SquashIcon;
